import {Component, OnInit} from '@angular/core';
import {PreloaderService} from "../../services/preloader/preloader.service";
import {StudentService} from "../../services/mygreencountry/student.service";
import {CountricsHistory} from "../../types/interfaces";
import {MyGreenCountry} from "../../services/mygreencountry/my-greencountry";
import {CountricsUrls} from "../../types/apiResponse.interface";
import {COUNTRICS_LINKS} from "../../shared/constants";
import {DomSanitizer, SafeResourceUrl, Title} from "@angular/platform-browser";
import {ViewTestComponent} from "../../shared/components/modals/view-test/view-test.component";
import {ModalController} from "@ionic/angular";
import {TranslocoService} from "@jsverse/transloco";
import {Observable} from "rxjs";

@Component({
    selector: 'app-countrics',
    templateUrl: './countrics.page.html',
    styleUrls: ['./countrics.page.scss'],
})
export class CountricsPage implements OnInit {
    title$: Observable<string>;
    lang = 'uk';

    public countrics: number = 0;
    public history: CountricsHistory[] | [] = [];
    public url: CountricsUrls = COUNTRICS_LINKS;
    public showMoreBottom: boolean = false;
    public videoUrl: string;


    constructor(private preloaderService: PreloaderService,
                private studentService: StudentService,
                public myGcService: MyGreenCountry,
                private sanitizer: DomSanitizer,
                private modalCtrl: ModalController,
                private translocoService: TranslocoService,
                private titleService: Title,
    )
    {
        this.translocoService.langChanges$.subscribe(language => {
            this.lang = language;
        })

        this.title$ = this.translocoService.selectTranslate('route.countrics');

        this.title$.subscribe(title => {
            this.titleService.setTitle(title);
        });

    }

    ngOnInit() {
        // console.log('lod')
        //
        // this.loadCountrics();

    }

    ionViewDidEnter() {
        this.loadCountrics();
    }

    refresh(event: any) {
        this.loadCountrics(false, event);

    }

    async loadCountrics(withoutLimit: boolean = false, event: any = null) {
        await this.preloaderService.showLoading("Зачекайте, будь ласка ");

        this.studentService.getCountricsHistory(withoutLimit)
            .subscribe({

                next: (response) => {
                    this.history = response.history;
                    this.countrics = response.amount;
                    this.url = response.url
                    this.videoUrl = response.videoUrl;
                    this.showMoreBottom = response.moreStory;

                },

                error: (error) => {
                    console.log('error', error)
                },

                complete: () => {
                    this.preloaderService.hideLoading();
                    if (event) {
                        event.target.complete();
                    }
                }

            })
    }


    openUrl(url: string) {

        this.myGcService.openUrl(url);

    }

    async openModal(url: string) {
        const safeUrl: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

        const modal = await this.modalCtrl.create({
            component: ViewTestComponent,
            cssClass: 'full-height',
            componentProps: {
                url: safeUrl,
                isCountrics:true
            }
        });

        await modal.present();

        const {data, role} = await modal.onWillDismiss();

    }

}
